export default {
  data() {
    return {
      param:{
        id:0,
        // 선택형일 경우 item들
        choice_items:[],
        is_multiple: false,
        param_type:1,
        // 보여지는 이름
        name:'',
        field:'',
        format:'',
        label:'',
        type:'맞춤디비',
        placeholder: '',
        description: '',
        validate: {
          required: true,
          valid_required: true
        },
        options: {

        }
      },
      // 타입별로 필요한 옵션값
      options: {},
      param_type_arr:[
        { label: '문자형', param_type: 0, value: 'CInput_text', type: 'text' },
        /*{ label: '숫자(정수)형', param_type: 1, value: 'CInput_number', type: 'integer'},
        { label: '숫자(실수)형', param_type: 2, value: 'CInput_float', type: 'float' },*/
        { label: '숫자(정수)형', param_type: 1, value: 'CRange', type: 'number_range' },
        { label: '숫자(실수)형', param_type: 2, value: 'CFloatRange', type: 'number_range' },
        { label: '선택형(체크박스)', param_type: 3, value: 'CCheckboxGroup', type: 'choice_checkbox' },
        { label: '선택형(라디오박스)', param_type: 3, value: 'CRadiobuttonGroup', type: 'choice_radio' },
        { label: '지역형', param_type: 4, value: 'CRegionForm', type: 'region' },
        { label: '주소형', param_type: 5, value: 'CAddress', type: 'address' },
        { label: '주소 리스트형', param_type: 13, value: 'CAddressList', type: 'addresslist' },
        { label: '직선형 스탭', param_type: 6, value:'CLinear', type: 'linear', options: {
            range:{
              max: {
                label: '',
                val: 5
              },
              min: {
                label: '',
                val: 1
              }
            }
          }
        },
        { label: '날짜', param_type: 7, value: 'CDate', type: 'date' },
        { label: '시간', param_type: 9, value: 'CTime', type: 'time' },
        { label: '날짜 + 시간', param_type: 10, value: 'CDateTime', type: 'date_time' },
        { label: '날짜범위', param_type: 11, value: 'CDateRange', type: 'date_range' },
        { label: '날짜 + 시간 범위', param_type: 12, value: 'CDateTimeRange', type: 'date_time_range' },
        { label: '파일업로드형', param_type: 8, value: 'CFileUploader', type: 'file' },
        { label: '이미지업로드형', param_type: 8, value: 'CImgUploader', type: 'file' },
        { label: '장문형', param_type: 14, value: 'CInputEditor', type: 'text' },
        { label: '색상', param_type: 3, value: 'CColorPicker', type: 'choice_color'},
        { label: '성별', param_type:3, value: 'CGender', type: 'choice_radio'},
      ]
    }
  },
  watch: {
    'param.format' (n) {
      if(this.$route.query.id===undefined) {
        if(this.param.format==='CColorPicker') {
          if(this.param.choice_items.length===0) {
            this.param.choice_items.push({
              name:'흰색',
              color: '#ffffff'
            })
          }
        }
        else if(this.param.format==='CCheckboxGroup'|| this.param.format==='CRadiobuttonGroup') {
          if(this.param.choice_items.length===0) {
            this.param.choice_items.push({
              name: 'item1'
            })
          }
        }
      }
    }
  },
  methods: {
    addColorItem () {
      let item = {
        name: '흰색',
        color: '#ffffff'
      }
      this.param.choice_items.push(item);
    },
    convertFormat(name) {
      let el = find(this.param_type_arr, 'value', name);
      return el ? el.label : '';
    },
    initEl(value) {
      let el = find(this.param_type_arr, 'value', value);
      this.param.format = el.value;
      this.param.param_type = el.param_type;
      this.param.type = el.type;
      this.param.choice_items = [];

      if(value === 'CLinear') {
        this.param.options = el.options;
        this.getLinearOptions();
      } else if(value === 'CGender') {
        this.param.choice_items = [
          {
            name: '남성'
          },
          {
            name: '여성'
          },
        ]
      }

      return el;
    },
    getLinearOptions(){
      //범위용 드롭다운 데이터 생성
      this.options = {
        linear: {
          min:[],
          max:[]
        }
      }
      for(let i=0; i<=10; i++) {
        if(i<2) this.options.linear.min.push({ value:i, label:i });
        else this.options.linear.max.push({ value:i, label:i });
      }
    },
    // 맞춤 DB 타입 클릭시
    clickParamType(n){
      this.param.options = {};
      this.initEl(n);
    }
  }
}
